export default __webpack_public_path__ + "static/media/servicios-img-1.fc396a8e.svg";